
import Switch from '@mui/material/Switch';
import { useState } from 'react';
import { useSelector } from 'react-redux';
// import LoadingShort from '../load/loadingShort';
// import { SILENT_LOGIN } from '../actions/accountActions';
import api from '../../services/api';
import LoadingShort from '../../load/loadingShort';

export default function ButtonSwitchSistem({ url, title, definicao, definicoes, setdefinicoes, descricao, verificacaoSimples, width }) {
  const user = useSelector((state) => state.account.user);
  const [load, setLoad] = useState(false);
  // const dispatch = useDispatch();

  async function togglePermission() {
    setLoad(true);

    await api.patch(url, {
      userId: user._id,
      descricao,
      definicao,
    })
      .then((response) => {
        setdefinicoes(response.data.definicoesSistema)
      })
      .catch((error) => {
      }).finally(() => setLoad(false))
  }


  return (
    <div style={{ width: width ?? 350, display: 'flex', alignItems: 'center', marginLeft: 5 }}>

      <span style={{ flexGrow: 1 }}>
        {title}
      </span>

      {load ?
        <LoadingShort />
        :
        <Switch
          color='secondary'
          style={{ width: 50 }}
          checked={definicoes?.includes(definicao) || definicoes?.includes(verificacaoSimples ? definicao : 'alldefinicoes')}
          onChange={togglePermission}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      }
    </div>
  );
}
